/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import BrandIcon from '../icons/BrandIcon';
import Image from './Image';

import styles from '../../styles/partials/collection-image.module.css';

const propTypes = {
    title: PropTypes.string,
    media: AppPropTypes.image,
    brand: PropTypes.string,
    withoutBrandIcon: PropTypes.bool,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    brandIconClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    media: null,
    brand: null,
    withoutBrandIcon: false,
    className: null,
    iconClassName: null,
    brandIconClassName: null,
};

function CollectionImage({
    title,
    media,
    brand,
    withoutBrandIcon,
    className,
    iconClassName,
    brandIconClassName,
    ...props
}) {
    if (media === null) {
        return (
            <div
                className={classNames([
                    styles.container,
                    styles.empty,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                {title}
            </div>
        );
    }
    return (
        <Image
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            loading="lazy"
            media={media}
            {...props}
        >
            {brand !== null && !withoutBrandIcon ? (
                <BrandIcon
                    type={brand}
                    className={classNames([
                        styles.icon,
                        styles.brandIcon,
                        {
                            [iconClassName]: iconClassName !== null,
                            [brandIconClassName]: brandIconClassName !== null,
                        },
                    ])}
                />
            ) : null}
        </Image>
    );
}

CollectionImage.propTypes = propTypes;
CollectionImage.defaultProps = defaultProps;

export default CollectionImage;
